
import { Vue, Component } from 'vue-property-decorator';
import auth from '@/services/auth';
import { parseConfirmationQuery } from '@/utils/parseConfirmationQuery';

import UiButton from '@/components/button/ui-button.vue';
import AuthFormLink from '@/components/auth/AuthFormLink.vue';
import AuthCard from '@/components/auth/AuthCard.vue';
import FormGroup from '@/components/form/FormGroup.vue';
import { NOTIFICATION } from '@/entities/Events';
import Message, { MessageDuration } from '@/data/notificationsMessages';
import RouteNames from '@/entities/RouteNames';

@Component({
	components: {
		UiButton,
		AuthFormLink,
		AuthCard,
		FormGroup,
	},
})
export default class AcceptInvitation extends Vue {
	loading: boolean = false;
	username: string = '';
	temporaryPassword: string = '';
	newPassword: string = '';
	confirmPassword: string = '';

	created(): void {
		this.checkConfirmation();
	}

	async checkConfirmation(): Promise<void> {
		this.loading = true;
		const [username, confirmation_code] = parseConfirmationQuery(
			this.$route.query
		);
		this.username = (username as string).replace(' ', '+');
		const uri = `${process.env.VUE_APP_LAMBDA}/check-user-confirmed`;
		const { data: userConfirmed }: any = await this.axios.post(uri, {
			data: {
				email: this.username.toLowerCase(),
			},
		});
		if (userConfirmed.confirmed) {
			this.$router.replace({ name: RouteNames.PROFILE });
		}
		this.temporaryPassword = confirmation_code as string;
		this.loading = false;
	}

	async submit(): Promise<void> {
		this.loading = true;
		try {
			const email = this.username.toLowerCase();
			const userAuth = await auth.signIn(email, this.temporaryPassword);
			if (
				userAuth &&
				userAuth.challengeName === 'NEW_PASSWORD_REQUIRED'
			) {
				await auth.completeNewPassword(userAuth, this.newPassword);
			}

			this.$eventBus.emit(
				NOTIFICATION,
				Message.successMessage(
					'The password had been successfully updated'
				)
			);
		} catch (e) {
			this.$eventBus.emit(
				NOTIFICATION,
				Message.errorMessage(e.message, MessageDuration.LONG)
			);
		} finally {
			this.loading = false;
		}
	}
}
